import React, { memo, PropsWithChildren, ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { cn } from 'lib/utils';
import { IconClose28 } from '@app/icons';

export interface ModalProps {
  visible?: boolean;
  className?: string;
  contentClassName?: string;
  onClose?: () => void;
  title?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'signin';
  contentStyles?: React.CSSProperties;
  header?: ReactNode;
  children?: ReactNode;
}

function Modal({
  visible = false,
  className = '',
  contentClassName = '',
  onClose,
  title,
  size = 'medium',
  contentStyles,
  header,
  children,
}: PropsWithChildren<ModalProps>) {
  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent
        className={cn('flex flex-col', className, {
          'max-w-sm': size === 'small',
          'max-w-lg': size === 'medium',
          'max-w-3xl': size === 'large',
          'max-w-full': size === 'xlarge' || size === 'signin',
        })}
        style={contentStyles}
      >
        {header}
        {!!title && (
          <DialogHeader className="flex flex-row justify-between items-center flex-shrink-0">
            <DialogTitle>{title}</DialogTitle>
            {/*<button*/}
            {/*  type="button"*/}
            {/*  onClick={onClose}*/}
            {/*  className="ml-2 rounded p-1 bg-transparent hover:bg-transparent border-0"*/}
            {/*>*/}
            {/*  <IconClose28 />*/}
            {/*</button>*/}
          </DialogHeader>
        )}
        <div
          className={cn(
            'flex-1 overflow-y-auto overflow-x-hidden min-h-0 scrollbar-hide',
            contentClassName
          )}
        >
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default memo(Modal);
